exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-checkout-steps-styles-___payment-form__paymentFormAction___1qX-k{display:flex;justify-content:end;width:100%}.src-components-checkout-steps-styles-___payment-form__cardData___3LaX-{display:flex;flex-direction:column;margin:20px 0}", ""]);

// exports
exports.locals = {
	"paymentFormAction": "src-components-checkout-steps-styles-___payment-form__paymentFormAction___1qX-k",
	"cardData": "src-components-checkout-steps-styles-___payment-form__cardData___3LaX-"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/checkout-steps/styles/payment-form.scss
 ** module id = 890
 ** module chunks = 0
 **/